module.exports = __webpack_public_path__ + "img/rectangle_rounded.28a5b0e2.svg";